import { useForm } from 'react-hook-form';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { makeCall } from 'utils/utils';
import { CreateFormData as FormData, CreateFormPropsType as PropsType } from './types';
import { createDefaultValues as defaultValues } from './initialData';
import EnhancedTextField from 'components/EnhancedTextField';

export default function Create({ open, handleClose, refresh }: PropsType) {
  const {
    handleSubmit,
    formState: { errors, isSubmitting },
    control,
    reset,
  } = useForm<FormData>({ defaultValues });

  const resetForm = () => {
    reset(defaultValues);
    handleClose();
  };

  const onSubmit = async (data: FormData) => {
    const payload = {
      ...data,
    };
    await makeCall('currencies', 'POST', payload);
    reset(defaultValues);
    handleClose();
    refresh();
  };
  return (
    <Dialog
      open={open}
      disableBackdropClick={true}
      onEscapeKeyDown={resetForm}
      onClose={handleClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">Create New Currency</DialogTitle>
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogContent>
          <EnhancedTextField
            control={control}
            required={true}
            fieldName="currencyCode"
            label="Currency code"
            hasError={errors.currencyCode ? true : false}
            errorTxt="Currency Code is required!"
            autoFocus
          />
          <EnhancedTextField control={control} required={false} fieldName="currencyLeft" label="Currency left" />
          <EnhancedTextField control={control} required={false} fieldName="currencyRight" label="Currency right" />
          <EnhancedTextField
            control={control}
            fieldName="currencyDecimalPlace"
            hasError={errors.currencyDecimalPlace ? true : false}
            errorTxt="Decimal place is required!"
            label="Currency decimal place"
          />
          <EnhancedTextField
            control={control}
            fieldName="currencyDecimalSeparator"
            hasError={errors.currencyDecimalSeparator ? true : false}
            errorTxt="Decimal separator is required!"
            label="Currency decimal separator"
          />
          <EnhancedTextField
            control={control}
            fieldName="currencyThousandSeparator"
            hasError={errors.currencyThousandSeparator ? true : false}
            errorTxt="Thousand separator is required!"
            label="Currency thousand separator"
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={resetForm} color="primary">
            Cancel
          </Button>
          <Button disabled={isSubmitting} type="submit" color="primary">
            {isSubmitting ? 'Creating...' : 'Create'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
